
<template>
<div class="vehicles-container tabbed-content">
  <chc-loader ref="loader"></chc-loader>
  <datatable
    :source="vehicles"
    :isLoading="isLoading">
    <datatable-column
      v-for="(column, index) in columns"
      :id="column.id"
      :label="column.label"
      :key="index">
    </datatable-column>

    <template slot="searchLeft">
      <a @click="downloadVehiclesCSV()"><span><i class="far fa-file-excel"></i></span> Download Selected Vehicles (CSV)</a>
    </template>

    <template slot="source_template" slot-scope="data">
      <tr>
        <td class="table-checkbox"><chc-checkbox v-model="data.row.download"></chc-checkbox></td>
        <td>{{ data.row.ref_number }}</td>
        <td>{{ data.row.entry_date }}</td>
        <td>{{ data.row.donor_name }}</td>
        <td>{{ data.row.year_make_model }}</td>
        <td>{{ data.row.sale_price }}</td>
        <td>{{ data.row.adj_gross_proceeds }}</td>
        <td>{{ data.row.charity_proceeds }}</td>
        <td>{{ data.row.charity_paid }}</td>
      </tr>
    </template>

    <template slot="tfoot" slot-scope="data">
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>TOTAL PROCEEDS</td>
        <td>{{ total_proceeds }}</td>
        <td></td>
      </tr>
    </template>
  </datatable>
</div>
</template>

<script>
import Datatable from '@/components/Datatables/AppDatatable'
import DatatableColumn from '@/components/Datatables/AppDatatableColumn'
import store from '@/store'
import helpers from '@/helpers'

export default {
  name: 'CharityVehiclesPreview',
  props: [],
  mounted () {
    Promise.all([
      store.functions.preview.getVehicles((response) => {
        this.vehicles = response.data.table_data
        this.total_proceeds = response.data.total_proceeds
      })
    ]).then(response => {
      // pass
    }).finally(() => {
      this.isLoading = false
    })
  },
  data () {
    return {
      loadingVehiclePage: false,
      isLoading: true,
      vehicles: [],
      total_proceeds: 0,

      columns: [
        { id: 'download', label: ' ' },
        { id: 'ref_number', label: 'Ref #' },
        { id: 'entry_date', label: 'Entry Date' },
        { id: 'donor_name', label: 'Donor Name' },
        { id: 'year_make_model', label: 'Year/Make/Model' },
        { id: 'sale_price', label: 'Sale Price' },
        { id: 'adj_gross_proceeds', label: 'Adj. Gross Proceeds' },
        { id: 'charity_proceeds', label: 'Charity Proceeds' },
        { id: 'charity_paid', label: 'Charity Paid' }
      ]
    }
  },
  computed: {
    downloadVehiclesIds () {
      let ids = []
      for (var i = this.vehicles.length - 1; i >= 0; i--) {
        if (this.vehicles[i].download) ids.push(this.vehicles[i].id)
      }
      if (ids.length > 0) return ids
      return []
    }
  },
  components: {
    Datatable,
    DatatableColumn
  },
  methods: {
    refresh () {
    },
    downloadVehiclesCSV () {
      store.functions.preview.downloadVehiclesCSV({ids: JSON.stringify(this.downloadVehiclesIds)})
        .catch((error) => console.log(error))
        .then((response) => {
          helpers.openAsDownload(response.data, 'charity_vehicles_' + (new Date()).toJSON() + '.csv')
        })
    },
  }
}
</script>

<style lang="scss" scoped>
.vehicles-container {
  padding-top: 2em;
}
td.table-checkbox, td.table-checkbox * {
    width: 25px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PreviewAccount/CharityVehiclesPreview.vue